export default "__VITE_ASSET__BSUEvs6d__"